<template>
  <div class="relative z-10">
    <input
      autocomplete="off"
      class="text-sm quick-search"
      name="site_search_keyword"
      maxlength="50"
      placeholder="Busca en nuestra tienda"
      ref="quickSearchInput"
      type="text"
      @input="typedIn"
      v-model="keyword">
    <div
      class="absolute overflow-y-scroll bg-white shadow-lg w-full pt-2 bordered-list"
      v-click-outside="hideResults"
      v-if="resultsShown" style="height:400px">
      <div class="text-gray-500 text-center py-8 leading-tight" v-if="resultsProducts.length == 0 && resultsCategories.length == 0 && resultsBrands.length == 0">No encontramos resultados para tu búsqueda.<br>Intenta con algo más.</div>
      <template v-else>
        <div class="mb-2 item light" v-if="resultsProducts.length > 0">
          <div class="flex flex-row px-4">
            <div class="flex-1 font-lg font-light text-gray-700">Productos</div>
            <div class="flex-none hidden md:block ml-2"><a :href="`/busqueda?site_search_keyword=${keyword}`" class="link-basic text-xs text-gray-700">Ver todo</a></div>
          </div>
          <div class="flex flex-row flex-wrap">
            <div
              class="w-full xl:w-1/2"
              :key="`quick-search-results-prod-${i}`"
              v-for="(product, i) in resultsProducts">
              <a
                class="flex flex-row items-center hover:text-main hover:bg-gray-100 st-all p-2"
                :href="`/productos/${product.slug}?searched=quick-search`">
                <div class="flex-none w-12 xl:w-16 mr-2"><img :src="product.image_thumb" :alt="product.name"></div>
                <div class="flex-1 leading-tight">
                  <p class="text-sm xl:text-base font-bold group-hover:text-main">{{ product.name }}</p>
                  <p class="text-gray-700 text-xs no-underline">{{ product.brand }}</p>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="mb-2 item light leading-tight" v-if="resultsCategories.length > 0">
          <div class="flex flex-row px-4">
            <div class="flex-1 font-lg font-light text-gray-700">Categorías</div>
            <div class="flex-none hidden md:block ml-2"><a :href="`/busqueda?site_search_keyword=${keyword}`" class="link-basic text-xs text-gray-700">Ver todo</a></div>
          </div>
          <div class="flex flex-row flex-wrap">
            <div
              class="w-full xl:w-1/2"
              :key="`quick-search-results-cat-${i}`"
              v-for="(category, i) in resultsCategories">
              <a
                class="flex flex-row items-center hover:text-main hover:bg-gray-100 st-all p-2"
                :href="`/categorias/${category.slug}?searched=quick-search`">
                <div class="flex-none w-16 mr-2"><img :src="category.image_thumb" :alt="category.name"></div>
                <div class="flex-1 leading-tight">
                  <p class="text-sm xl:text-base font-bold group-hover:text-main">{{ category.name }}</p>
                  <p class="text-gray-700 text-xs no-underline">{{ category.products_count == 1 ? '1 producto' : `${category.products_count} productos` }}</p>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="mb-2 item light" v-if="resultsBrands.length > 0">
          <div class="flex flex-row px-4">
            <div class="flex-1 font-lg font-light text-gray-700">Marcas</div>
            <div class="flex-none hidden md:block ml-2"><a :href="`/busqueda?site_search_keyword=${keyword}`" class="link-basic text-xs text-gray-700">Ver todo</a></div>
          </div>
          <div class="flex flex-row flex-wrap">
            <div
              class="w-full xl:w-1/2"
              :key="`quick-search-results-prod-${i}`"
              v-for="(brand, i) in resultsBrands">
              <a
                class="flex flex-row items-center hover:text-main hover:bg-gray-100 st-all p-2"
                :href="`/marcas/${brand.slug}?searched=quick-search`">
                <div class="flex-none w-16 mr-2"><img :src="brand.image_thumb" :alt="brand.name"></div>
                <div class="flex-1 leading-tight">
                  <p class="text-sm xl:text-base font-bold group-hover:text-main">{{ brand.name }}</p>
                  <p class="text-gray-700 text-xs no-underline">{{ brand.products_count == 1 ? '1 producto' : `${brand.products_count} productos` }}</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>
<script>
import { directive as onClickaway } from 'vue-clickaway';
import {debounce} from '@utilities/Debounce.js';
export default {
  name: 'site-quick-search',
  directives: { 'click-outside': onClickaway },
  props: {
    initKeyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      resultsProducts: [],
      resultsCategories: [],
      resultsBrands: [],
      resultsShown: false,
      keyword: ''
    }
  },
  mounted (){
    this.keyword = this.initKeyword;
    // document.body.addEventListener('keyup', this.slashKeyUpFunction);
  },
  beforeDestroy() {
    // document.body.removeEventListener('keyup', this.slashKeyUpFunction);
  },
  methods: {
    hideResults() {
      this.resultsShown = false;
    },
    // slashKeyUpFunction(e) {
    //   let activeElement = document.activeElement;

    //   if (activeElement != null) {
    //     let tagName = activeElement.tagName;
    //     if (['INPUT', 'TEXTAREA'].indexOf(tagName) >= 0) {
    //       return;
    //     }
    //   }

    //   if (e.keyCode === 191 || e.keyCode === 111) {
    //     this.$refs.quickSearchInput.focus();
    //   }
    // },
    typedIn: debounce(
      function () {
        this.resultsShown = false;
        this.resultsProducts = [];
        this.resultsCategories = [];
        this.resultsBrands = [];
        if (this.keyword.length < 3) {
          return;
        }
        
        axios.post(`/busqueda-rapida?keyword=${this.keyword}`)
        .then(response => {
          this.resultsProducts = response.data.data.products;
          this.resultsCategories = response.data.data.categories;
          this.resultsBrands = response.data.data.brands;
          this.resultsShown = true;
        })
        .catch(error => {
          // alert('Lo sentimos, ocurrió algo extraño. Intenta nuevamente.');
        });

      },
      400
    ),
  }
}
</script>